import './travel-preview.scss';

import { createElementFromHTML, serializeForm } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';

class TravelPreview {
    constructor (element) {
        this.$travelPreview = element;
        this.$results = this.$travelPreview.querySelector('[data-travel-preview="results"]');
        this.$resultsCounter = this.$travelPreview.querySelector('[data-travel-preview-counter]');
        this.$form = this.$travelPreview.querySelector('[data-quickstart-filter="form"]');
        this.$pagination = null;

        this.ajaxURL = this.$form?.getAttribute('action');
        this.ajaxActive = false;
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$form?.addEventListener('submit', (e) => {
            e.preventDefault();
            this.ajaxURL = this.$form?.getAttribute('action');
            this.checkBeforeSubmit(0);
        });

        window.onpopstate = (e) => {
            if (e.state === null) {
                location.replace(window.location.href);
            }
        };

        // init call
        this.handlePaginationChange(this.$travelPreview);

        window.addEventListener('content.loaded', (e) => {
            this.handlePaginationChange(e.detail.$context);
        });
    }

    handlePaginationChange ($paginationParent) {
        this.$pagination = $paginationParent.querySelector('[data-travel-preview="pagination"]');
        this.$$paginationLinks = this.$pagination?.querySelectorAll('a');
        this.$paginationSelect = this.$pagination?.querySelector('select');

        this.$$paginationLinks?.forEach($paginationLink => {
            $paginationLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.ajaxURL = e.target.href;
                this.checkBeforeSubmit(0, true, this.ajaxURL);
            });
        });

        if (this.$paginationSelect) {
            this.$paginationSelect.addEventListener('change', (e) => {
                e.preventDefault();
                this.ajaxURL = e.target.value;
                this.checkBeforeSubmit(0, true, this.ajaxURL);
            });
        }
    }

    checkBeforeSubmit (timer = 0, paginationChangePage = false, setUrl = null) {
        clearTimeout(this.waitTimer);

        if (this.ajaxActive === false) {
            this.waitTimer = setTimeout(() => {
                this.$results.appendChild(createElementFromHTML(window.OPTIONS.loader));
                this.sendRequest(paginationChangePage, setUrl);
                this.ajaxActive = true;
            }, timer);
        } else {
            console.log('Please wait.....Request is running');
        }
    }

    setHistory (paginationChangePage = false, setUrl = null) {
        let url = null;

        if (paginationChangePage === false) {
            url = this.$form.dataset.formAction + '?' + serializeForm(this.$form);
        } else {
            url = setUrl;
        }

        history.pushState(null, null, url);
    }

    sendRequest (paginationChangePage = false, setUrl = null) {
        const formData = new FormData(this.$form);

        this.setHistory(paginationChangePage, setUrl);

        this.result = new AjaxLoad(this.ajaxURL, {
            requestMethod: 'post',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.setResult(results);
            },
            onError: (error) => {
                console.warn(error);
                this.ajaxActive = false;
                this.$results.innerHTML = `<div class="travel-preview__no-results icon-info rte">${window.translations.travelPreview.error}</div>`; // this prevents the user from infinite loading screen
            }
        });
    }

    setResult (results) {
        this.ajaxActive = false;
        const $result = createElementFromHTML(results.html);
        this.$results.innerHTML = '';

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$results.appendChild(item);
            });
        } else {
            this.$results.appendChild($result);
        }

        if (results.count) {
            if (this.$resultsCounter) {
                this.$resultsCounter.innerText = results.count;
            }
        } else {
            if (this.$resultsCounter) {
                this.$resultsCounter.innerText = '0';
            }
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$results
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        window.bookmark.initialize(this.$results);
    }
}

export { TravelPreview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $travelPreview = $context.querySelector('[data-travel-preview="root"]');

        if ($travelPreview) {
            const travelPreview = new TravelPreview($travelPreview);
            travelPreview.initialize();
        }
    }
});
